import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { addJsonLdArticle } from '@/actions/JsonLdActions';
import { ReleaseOneView } from '@/components/pages/release/ReleaseOneView';
import Layout from '@/container/Layout';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { getAbsolutePath, releaseOnePath } from '@/utils/router/links';
const description = 'PROFFITはコンサル選定支援サービスです。累計80億円以上のコンサル相談実績があり、500社以上のコンサルティング会社から依頼内容や費用水準に合わせて最適なコンサルチームを選定することが出来ます。';
/**
 * ニュース詳細ページ
 * @param props
 * @returns
 */
export const ReleaseOnePage = (props) => {
    const { isGuestUser, releaseOneData } = props;
    const dispatch = useDispatch();
    const title = `${releaseOneData.title} | PROFFIT`;
    const url = getAbsolutePath(releaseOnePath(`${releaseOneData.id}`));
    // JSON-LD 追加
    useEffect(() => {
        const jsonLd = {
            author: [],
            datePublished: releaseOneData.display_from_at,
            headline: releaseOneData.title,
            image: [],
            mainEntityOfPage: url,
        };
        dispatch(addJsonLdArticle(jsonLd));
    }, [dispatch, releaseOneData, url]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: url, property: 'og:url' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(ReleaseOneView, { isGuestUser: isGuestUser, releaseOneData: releaseOneData })] })));
};
